import { cn } from "../utils";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: keyof (typeof buttonVariants)["variant"];
  size?: keyof (typeof buttonVariants)["size"];
  loading?: boolean;
}

const buttonVariants = {
  baseClass:
    "flex focus-visible:ring-ring relative hover:border-[#a0a0a0] font-semibold inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md transition-colors focus-visible:outline-none cursor-pointer focus-visible:ring-1 disabled:pointer-events-none disabled:cursor-default disabled:opacity-50",

  variant: {
    primary: "bg-[#fbfbfb] border border-[#e0e0e0] text-[#21272e] hover:bg-gray-50",
    successes: "bg-green-600 text-white hover:bg-green-700 disabled:bg-gray-300 disabled:text-gray-500",
    destructive: "bg-red-600 text-white hover:bg-red-700",
    icon: "border border-[#e0e0e0] bg-white"
  },
  size: {
    sm: "h-8 px-2 text-xs",
    md: "h-9 px-3 text-xs",
    lg: "h-10 px-4 text-sm"
  },
  defaults: {
    variant: "primary",
    size: "md"
  }
} as const;

export function Button({
  children,
  variant = buttonVariants.defaults.variant,
  size = buttonVariants.defaults.size,
  loading = false,
  className = "",
  ...props
}: ButtonProps) {
  return (
    <button
      className={cn(buttonVariants.baseClass, buttonVariants.variant[variant], buttonVariants.size[size], className)}
      disabled={props.disabled || loading}
      type={props.type || "button"}
      {...props}
    >
      <span className={loading ? "invisible" : "visible"}>{children}</span>
      {loading && (
        <span className='absolute flex items-center justify-center inset-0'>
          <span className='animate-spin rounded-full h-4 w-4 border-2 border-[#a0a0a0] border-t-transparent' />
        </span>
      )}
    </button>
  );
}
